import type { ApiNodeDataCollectData } from '@onefootprint/request-types/dashboard';
import type { TFunction } from 'i18next';
import type { NodeData } from '../../../../playbook-builder.types';

export const getCollectDataSubtitle = (
  data: NodeData<ApiNodeDataCollectData>,
  t: TFunction<'playbook-builder'>,
): string => {
  const parts: string[] = [];

  if (data.subject === 'business') {
    parts.push(t($ => $.collectData.business.title));
  } else {
    parts.push(t($ => $.collectData.person.personal.title));
  }

  if (data.mustCollectData.includes('investor_profile')) {
    parts.push(t($ => $.collectData.person.investor.title));
  }

  if (data.customRequirements.length === 1) {
    parts.push(`1 ${t($ => $.collectData.person.customDataPage)}`);
  } else if (data.customRequirements.length > 1) {
    parts.push(`${data.customRequirements.length} ${t($ => $.collectData.person.customDataPages)}`);
  }

  return parts.join(', ');
};
